/**
 * Uma autoridade para "o que deu errado" numa chamada da API (M-B B1, 28/09). Antes cada tela lia
 * `e?.response?.data?.message` (umas `.error`, outras nada) e nenhuma distinguia rede × recusa × servidor.
 * `acao`: 'carregar' (leitura: repetir é seguro) | 'salvar' (escrita: timeout NÃO prova que falhou).
 */
const GENERICO_DO_NEST = 'Internal server error';

/** axios 1.x: estouro de `timeout` → `ECONNABORTED` (ou `ETIMEDOUT` com `transitional.clarifyTimeoutError`, xhr.js:144). */
export const ehTimeout = (e) => e?.code === 'ECONNABORTED' || e?.code === 'ETIMEDOUT';
/** Status HTTP da resposta; 0 quando não houve resposta (rede/timeout). `lib/query.ts` decide o retry por aqui. */
export const statusDe = (e) => (typeof e?.response?.status === 'number' ? e.response.status : 0);

export function erroDaApi(e, { acao = 'carregar' } = {}) {
  if (ehTimeout(e)) {
    return {
      tipo: 'timeout',
      texto: acao === 'carregar'
        ? 'O servidor demorou demais para responder.'
        : 'A resposta demorou demais. Pode ter sido feito — recarregue a tela antes de tentar de novo.',
    };
  }
  if (!e?.response) return { tipo: 'rede', texto: 'Sem conexão com o servidor. Confira a internet e tente de novo.' };
  const { status, data } = e.response;
  const bruto = data && typeof data === 'object' ? (data.message ?? data.error) : null;
  let msg = Array.isArray(bruto) ? bruto.join('; ') : typeof bruto === 'string' ? bruto : null;
  if (msg === GENERICO_DO_NEST) msg = null;
  if (status >= 500) return { tipo: 'servidor', status, texto: `O servidor falhou (${status}).${msg ? ` ${msg}` : ''}` };
  return { tipo: 'recusa', status, texto: msg || `O servidor recusou o pedido (${status}).` };
}
